<template>
  <div
    id="dashboard-sidebar"
    class="bg-secondary border-right py-5 h-100 d-flex flex-column justify-content-between"
    v-show="!isLoading"
  >
    <div
      class="d-flex flex-column flex-shrink-0"
    >
      <router-link
        :to="{ name: 'dashboard' }"
      >
        <img
          class="d-block w-75 mx-auto pl-1"
          src="/images/smartmatch-logo.png"
          alt="logo"
        >
      </router-link>
      <profile-details
        @setIsLoading="setIsLoading"
        class="my-6"
      />
      <b-button
        variant="pill"
        size="sm"
        class="d-block m-0 mx-auto"
      >
        <router-link
          class="router-link"
          :to="{ name: 'NewCampaignBlank' }"
          data-test="sidebar-new-campaign-button"
        >
          New Campaign
        </router-link>
      </b-button>
    </div>
    <div
      id="navigation-wrapper"
      class="flex-grow-1 my-5 d-flex flex-column"
    >
      <the-navigation
        v-if="!isLoading"
      />
      <div
        class="flex-grow-1 flex-shrink-0 d-flex flex-column justify-content-center"
      >
        <b-button
          variant="tertiary"
          class="sidebar-nav-btn d-flex flex-column align-items-center"
          data-test="nav-item-best-practices"
        >
          <a
            class="router-link d-flex flex-column align-items-center"
            href="https://a.smartology.co/smartmatch-best-practice-content.pdf"
            target="_blank"
          >
            <i
              class="nav-icon fal fa-book-circle-arrow-right mx-auto"
            />
            <p
              class="mb-0 mt-2"
            >
              Best Practices
            </p>
          </a>
        </b-button>
      </div>
    </div>
    <div
      class="mb-2"
    >
      <b-button
        v-if="GET_IS_ADMIN"
        variant="footer"
        class="sidebar-nav-btn w-100 justify-content-between align-items-center"
        data-test="settings"
      >
        <p
          class="mb-0 mx-2"
        >
          <router-link
            class="router-link"
            :to="{ name: 'AccountSettings' }"
            data-test="sidebar-account-settings-button"
          >
            <i class="fa-light fa-gear mr-2" /> Settings
          </router-link>
        </p>
      </b-button>
      <b-button
        variant="footer"
        class="sidebar-nav-btn w-100 justify-content-between align-items-center"
        data-test="nav-item-signout"
        @click="signout"
      >
        <p
          class="mb-0 mx-2"
        >
          <i class="fal fa-sign-out mr-2" />
          Sign Out
        </p>
      </b-button>
      <b-button
        variant="link"
        class="sidebar-nav-btn w-100 justify-content-between align-items-center"
        href="https://www.smartology.net/demo/"
        target="_blank"
      >
        <p
          class="mb-0 mx-2"
        >
          <i class="fal fa-question-circle mr-2" />
          Help
        </p>
      </b-button>
    </div>
    <a
      class="header-brand mt-2 mx-auto"
      target="_blank"
      href="https://www.smartology.net/"
    >
      <img
        src="/images/bulb-icon.png"
        height="40"
        alt="Smartology"
      >
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as authenticationTypes from '@/modules/authentication/store/types';
import TheNavigation from '@/components/TheNavigation';
import ProfileDetails from '@/modules/account/components/ProfileDetails';

import urlHelper from '@/core/mixins/urlHelper';

export default {
  name: 'TheSidebar',
  mixins: [
    urlHelper,
  ],
  components: {
    ProfileDetails,
    TheNavigation,
  },
  data() {
    return {
      isLoading: true,
      userAttributes: {
        name: '',
        organization: '',
        role: '',
      },
    };
  },
  computed: {
    ...mapGetters('authentication', [
      authenticationTypes.GET_IS_ADMIN,
    ]),
  },
  methods: {
    ...mapActions('authentication', [
      authenticationTypes.SIGN_OUT,
    ]),
    async signout() {
      await this.SIGN_OUT();
      this.assignURLToCurrentTab(this.$router.resolve({ name: 'login' }).href);
    },
    setIsLoading(payload) {
      this.isLoading = payload;
    },
  },
};
</script>
<style lang="scss">
.sidebar-nav-btn {
  &:hover, &:focus, &.active {
    color: $body-color;
    background: $gray-200;
    border-radius: 0;
  }
  &.nav-border-left {
    &:hover, &:focus, &.active {
      border-left: 3px solid $primary;
    }
  }
  &.btn-link {
    &:hover, &:focus, &.active {
      text-decoration: none;
      color: $link;
  }
  }
}
</style>
<style lang="scss" scoped>
#dashboard-sidebar {
  max-height: 100vh;
  width: 130px;
  overflow: hidden;
}
.logo-container {
  height: 150px;
}
#navigation-wrapper {
  overflow-y: auto;
}
.router-link {
  all: unset;
}
</style>
